
var authorityList = [
    //左边导航的数据
    {
        name: "我的账户",
        icon: require("../assets/navIcon/icon_company.png"),
        activeIcon: require("../assets/navIcon/icon_company_active.png"),
        height: 0,
        href: "/myCenter",
        id: 1,
    },
    {
        name: "订单列表",
        icon: require("../assets/navIcon/icon_order.png"),
        activeIcon: require("../assets/navIcon/icon_order_active.png"),
        height: 0,
        href: "/orderManage",
        id: 2,
    }
];
export {
    authorityList
}



// WEBPACK FOOTER //
// ./src/config/authority.js